export const USER_LOCAL_STORAGE = '@simula-sisu-2026/user'

export const HAS_ALREADY_SENDED_ACTIVE_CAMPAIGN = '@simula-sisu-2026/active-campaign'
